import { DismissSparklines } from 'domain/usecases';
import { RemoteDismissSparklines } from 'data/usecases';
import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';

export const makeRemoteDismissSparklines = (): DismissSparklines => {
  return new RemoteDismissSparklines(makeApiUrl('/reports/graphs/dismiss'), makeAuthorizeHttpClientDecorator());
};
